<app-search-result-generic
  [result]="result"
  [crumbs]="['Documentation', result.productId | productName, result.version, book?.title]">
</app-search-result-generic>
